var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.hasLink ? 'BaseLink' : 'div',_vm._g(_vm._b({tag:"component",class:_vm.classNames},'component',_vm.linkProps,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }